<footer class="p-2 mt-5">
    <p class="text-center pt-3">Desenvolvido pela Safeweb Segurança da Informação Ltda - CNPJ: 01.579.286/0001-74 - Av. Princesa Isabel, 828 -
        Porto Alegre/RS -
        90620-000 © Copyright {{year}}</p>
</footer>